import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import logo from "../../../Images/logo.png";
import Download from "@mui/icons-material/Download";
import './Navigation.css';



const pages = ["Home", "About me", "Blog", "Resume"];

const Navigation = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <div>
      <AppBar
        position="static" 
        sx={{ boxShadow: 0, bgcolor: "rgba(20,25,67,.6)" ,color:'white' }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
            >
              <img
                style={{ width: "100px", margin: 0, paddingLeft: 10 }}
                src={logo}
                alt=""
                srcSet=""
              />
            </Typography>

            {/* hambuerger menu icon is there  */}
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>

              {/* The menu of mobile size starting here  */}
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page} ????? </Typography>
                  </MenuItem>
                ))}
                 <button className="download-resume"> <Download style={{marginBottom: -8}}/><a href="https://drive.google.com/file/d/1B7OC-f9BZ2QnQZITWS9SGeKgWVGDZ4gF/view?usp=sharing" target="_blank" rel="noreferrer"> Download Resume</a> </button>
              </Menu>
              {/* mobile menu end there  */}
            </Box>

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 2, display: { xs: "flex", md: "none", sm: "flex" } }}
            >
              <img
                style={{ width: "100px", margin: 0, padding: 0 }}
                src={logo}
                alt=""
                srcSet=""
              />
            </Typography>
            {/* The logo of mobile size  */}
            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
            ></Box>

            {/*  Laptop or computer size menu is there  */}
            <Box sx={{ flexGrow: 0 }}>
              <Box
                sx={{
                  flexGrow: 1,
                  display: { xs: "none", md: "flex" },
                  textAlign: "right",
                }}
              >
                {pages.map((page) => (
                  <Button
                    key={page}
                    onClick={handleCloseNavMenu}
                    //// white theke gray te nisi
                    sx={{
                      my: 2,
                      // color: "black",
                      display: "block",
                      fontSize: "20px",
                      color: 'white',
                    }}
                  >
                    {page}
                  </Button>
                ))} 
                <button className="download-resume"> <Download style={{ marginBottom: -8 }} />
                  <a href="https://drive.google.com/file/d/1B7OC-f9BZ2QnQZITWS9SGeKgWVGDZ4gF/view?usp=sharing" target="_blank" rel="noreferrer"> Download Resume</a>
                </button>
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

export default Navigation;
